import React, { Component } from "react"
import Slider from "react-slick"
import LeftArrow from "../../assets/images/ArrowLeft.png"
import RightArrow from "../../assets/images/ArrowRight.png"

import settings from "../../constants/restaurantSlider"
import { Button } from "../../atoms"

import "./Slider.scss"

export class RestaurantSlider extends Component {
  render() {
    const { children, showArrow, isDateWait } = this.props

    const next = () => {
      this.slider.slickNext()
    }
    const previous = () => {
      this.slider.slickPrev()
    }

    return (
      <div className="slider-container">
        <Slider ref={(c) => (this.slider = c)} {...settings}>
          {children}
        </Slider>
        {showArrow && (
          <div
            className="arrow-btn-container"
            style={isDateWait ? { zIndex: 1 } : {}}
          >
            <Button className="slider-arrow-btn" onClick={previous}>
              <img src={LeftArrow} alt="previous" />
            </Button>
            <Button className="slider-arrow-btn" onClick={next}>
              <img src={RightArrow} alt="next" />
            </Button>
          </div>
        )}
      </div>
    )
  }
}
